import { Controller } from '@hotwired/stimulus';
import application from '~/stimulus_application';

export default class ActiveItemGroup extends Controller {
  static targets = ['item'];

  declare readonly itemTargets: HTMLElement[];
  private activeItem: HTMLElement | null = null;

  connect() {
    this.initializeActiveState();
  }

  activate(event: Event) {
    const clickedItem = event.currentTarget as HTMLElement;

    // Use cached active item or find it if not set
    const currentActiveItem = this.activeItem || this.findActiveItem();

    if (currentActiveItem && currentActiveItem !== clickedItem) {
      this.deactivateItem(currentActiveItem);
    }

    this.activateItem(clickedItem);
  }

  private initializeActiveState() {
    // Cache the initially active item
    this.activeItem = this.findActiveItem() || null;
  }

  private findActiveItem(): HTMLElement | undefined {
    return this.itemTargets.find((item) => item.getAttribute('aria-current') === 'page');
  }

  private activateItem(item: HTMLElement) {
    const activeClasses = item.dataset.activeClasses;
    const inactiveClasses = item.dataset.inactiveClasses;

    if (inactiveClasses) {
      item.classList.remove(...inactiveClasses.split(' ').filter(Boolean));
    }
    if (activeClasses) {
      item.classList.add(...activeClasses.split(' ').filter(Boolean));
    }
    item.setAttribute('aria-current', 'page');
    this.activeItem = item;
  }

  private deactivateItem(item: HTMLElement) {
    const activeClasses = item.dataset.activeClasses;
    const inactiveClasses = item.dataset.inactiveClasses;

    if (activeClasses) {
      item.classList.remove(...activeClasses.split(' ').filter(Boolean));
    }
    if (inactiveClasses) {
      item.classList.add(...inactiveClasses.split(' ').filter(Boolean));
    }
    item.removeAttribute('aria-current');
    if (this.activeItem === item) {
      this.activeItem = null;
    }
  }
}

application.register('ui--active-item-group', ActiveItemGroup);
